var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPower1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "power"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 1.375V11H11.6875V1.375H10.3125Z",
    fill: "#005182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.125 12.1171C4.125 9.52956 5.5542 7.27487 7.66954 6.10107L7.00238 4.89877C4.46789 6.30516 2.75 9.01005 2.75 12.1171C2.75 16.6735 6.44365 20.3671 11 20.3671C15.5563 20.3671 19.25 16.6735 19.25 12.1171C19.25 9.06258 17.5896 6.39666 15.1255 4.97123L14.437 6.16144C16.4937 7.3512 17.875 9.57326 17.875 12.1171C17.875 15.9141 14.797 18.9921 11 18.9921C7.20304 18.9921 4.125 15.9141 4.125 12.1171Z",
    fill: "#005182"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower1);
export default __webpack_public_path__ + "static/media/power (1).a17472ac11a85b9a5f841b12dba71c82.svg";
export { ForwardRef as ReactComponent };